var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(759 458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -61.5L48.1 -38.4L60 13.7L26.7 55.5L-26.7 55.5L-60 13.7L-48.1 -38.4Z",
    fill: "none",
    stroke: "#3c29a6",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -50L39.1 -31.2L48.7 11.1L21.7 45L-21.7 45L-48.7 11.1L-39.1 -31.2Z",
    fill: "none",
    stroke: "#3c29a6",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(818 296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -28L21.9 -17.5L27.3 6.2L12.1 25.2L-12.1 25.2L-27.3 6.2L-21.9 -17.5Z",
    stroke: "#3c29a6",
    fill: "none",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -16L12.5 -10L15.6 3.6L6.9 14.4L-6.9 14.4L-15.6 3.6L-12.5 -10Z",
    stroke: "#3c29a6",
    fill: "none",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(324 126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -29L22.7 -18.1L28.3 6.5L12.6 26.1L-12.6 26.1L-28.3 6.5L-22.7 -18.1Z",
    stroke: "#3c29a6",
    fill: "none",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(594 218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -40L31.3 -24.9L39 8.9L17.4 36L-17.4 36L-39 8.9L-31.3 -24.9Z",
    stroke: "#3c29a6",
    fill: "none",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -54L42.2 -33.7L52.6 12L23.4 48.7L-23.4 48.7L-52.6 12L-42.2 -33.7Z",
    stroke: "#3c29a6",
    fill: "none",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69 511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -24L18.8 -15L23.4 5.3L10.4 21.6L-10.4 21.6L-23.4 5.3L-18.8 -15Z",
    stroke: "#3c29a6",
    fill: "none",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452 437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -41L32.1 -25.6L40 9.1L17.8 36.9L-17.8 36.9L-40 9.1L-32.1 -25.6Z",
    stroke: "#3c29a6",
    fill: "none",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoly);
export default __webpack_public_path__ + "static/media/poly.9dad4e20ca06ada9a8567dee5aca5b59.svg";
export { ForwardRef as ReactComponent };